<div
    [soti-tooltip]="isTextTruncated ? (!!tooltipText ? tooltipText : fullText) : ''"
    [placement]="placement"
    [delay]="tooltipDelay"
    class="ellipsis-tooltip" [style.white-space]="whiteSpace">
    <span class="inner-text-caption" [innerHTML]="fullText"></span>
</div>
